import { render, staticRenderFns } from "./fastServe.vue?vue&type=template&id=2c1f3378&scoped=true&"
import script from "./fastServe.vue?vue&type=script&lang=js&"
export * from "./fastServe.vue?vue&type=script&lang=js&"
import style0 from "./fastServe.vue?vue&type=style&index=0&id=2c1f3378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f3378",
  null
  
)

export default component.exports